"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.facebookAdsUpdateCustomAudience = exports.facebookAdsUpdateCustomAudienceResultSchema = exports.facebookAdsUpdateCustomAudienceArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.facebookAdsUpdateCustomAudienceArgsSchema = zod_1.z.object({
    audienceId: zod_1.z.string().describe('The ID of the custom audience to update'),
    emails: zod_1.z
        .array(zod_1.z.string().email())
        .min(1)
        .max(10000)
        .describe('Array of email addresses to add to the audience. Emails will be normalized (lowercased, trimmed) and hashed before upload. Maximum 10,000 emails per request.'),
    emitMode: zod_1.z.literal('single'),
});
exports.facebookAdsUpdateCustomAudienceResultSchema = zod_1.z.object({
    id: zod_1.z.string().describe('Custom audience ID'),
    users_added: zod_1.z.number().describe('Number of users successfully added'),
    users_invalid: zod_1.z
        .number()
        .nullable()
        .optional()
        .describe('Number of invalid entries (if provided by API)'),
    approximate_count: zod_1.z
        .number()
        .nullable()
        .optional()
        .describe('Approximate total audience size after adding users'),
});
exports.facebookAdsUpdateCustomAudience = (0, common_1.createToolMetadata)({
    id: 'facebookAdsUpdateCustomAudience',
    displayName: 'Add Users to Meta Custom Audience',
    displayDescription: 'Add users to an existing Custom Audience',
    category: 'ads',
    color: common_1.BRAND_COLORS.META,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.META),
    icon: 'meta',
    argsSchema: exports.facebookAdsUpdateCustomAudienceArgsSchema,
}, exports.facebookAdsUpdateCustomAudienceResultSchema);
